import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IPagination, IPaginationParams } from "@/types/pagination";
import type { IExamProgress } from "./types";

export interface IMyExamProgressListParams extends IPaginationParams {
  // Additional filters can be added here in the future
}

/**
 * 내 시험 진행 내역 목록을 조회하는 API 함수
 * @param params 쿼리 파라미터 (페이징)
 * @returns API 응답 객체
 */
export const apiGetMyExamProgressList = async (
  params?: IMyExamProgressListParams
) => {
  const response = await apiGet<IPagination<IExamProgress>>(
    "/exam_progress/mine",
    params
  );
  return response.data;
};

/**
 * 내 시험 진행 내역 목록을 React Query를 통해 조회하는 훅
 * @param params 쿼리 파라미터 (페이징)
 * @param options React Query 옵션
 * @returns 쿼리 결과
 */
export const useQueryGetMyExamProgressList = (
  params?: IMyExamProgressListParams,
  options = {}
) => {
  const queryKey = QueryKeys.examProgress.mine(params);

  return useQuery({
    queryKey,
    queryFn: async () => {
      return await apiGetMyExamProgressList(params);
    },
    ...options,
  });
};

export default useQueryGetMyExamProgressList;
